export default "<option value=\"<%= value %>\"><%= text %></option>";